import type { Person } from "../../../utils/backend-types";
import { type Doc } from "../../DeliveryOverview/DeliveryOverview.types";

function getDocumentName(
  persons: Array<Person>,
  documentType: Doc["documentType"],
  supplierId: Doc["supplier"],
  suppliedId: Doc["supplied"],
  invoiceData: Doc["invoiceData"]
): string {
  const supplier = supplierId
    ? persons.find((person) => person.id === supplierId)
    : undefined;
  const supplied = suppliedId
    ? persons.find((person) => person.id === suppliedId)
    : undefined;
  const supplierName = supplier ? supplier.name : "<Kein_Lieferant>";
  const suppliedName = supplied ? supplied.name : "<Kein_Belieferter>";
  const billingPeriod =
    invoiceData?.billingPeriodStart || "<Kein_Abrechnungsbeginn>";

  let prefix = "Rechnung";
  if (documentType === "draft") {
    prefix = "Vorschau";
  } else if (documentType !== "reversed") {
    if (invoiceData?.isAdvanceInvoice) {
      prefix = "Abschlagsrechnung";
    } else if (invoiceData?.isCorrectionInvoice) {
      prefix = "Korrekturrechnung";
    }
  }

  const text = `${prefix}_${supplierName}_${suppliedName}_${billingPeriod}`;

  return text;
}

export { getDocumentName };
